export default "__VITE_ASSET__BpZeyDSy__"